/** Backup codes are stored and compared by the server in XXXX-XXXX format. */
export function formatBackupCodeForRequest(value: string): string {
  const compact = value.trim().replace(/-/g, '')
  return compact.length === 8 ? `${compact.slice(0, 4)}-${compact.slice(4)}` : value.trim()
}
